import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
const plans = [{
  id: 1,
  name: 'Monthly',
  price: '$29',
  period: 'per month',
  features: ['Access to all trading classes', 'New classes added monthly', 'Trading worksheets & resources', 'Mobile and desktop access', 'Cancel anytime']
}, {
  id: 2,
  name: 'Annual',
  price: '$240',
  period: 'per year',
  savings: 'Save $108',
  popular: true,
  features: ['Everything in Monthly plan', 'Exclusive webinars with experts', 'Market analysis reports', 'Trading strategy templates', 'Priority support']
}];
export function PricingSection() {
  return <section className="py-20 bg-zinc-900" data-id="element-170">
      <div className="container mx-auto px-4" data-id="element-171">
        <div className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-173">
            Choose Your Membership
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-174">
            Get unlimited access to all classes and resources with our flexible
            membership options.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-175">
          {plans.map(plan => <div key={plan.id} className={`bg-black rounded-lg p-8 border ${plan.popular ? 'border-red-600' : 'border-gray-800'} relative`} data-id="element-176">
              {plan.popular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-1 rounded-full text-sm font-medium" data-id="element-177">
                  Most Popular
                </div>}
              <h3 className="text-2xl font-bold mb-2" data-id="element-178">{plan.name}</h3>
              <div className="mb-6" data-id="element-179">
                <span className="text-4xl font-bold" data-id="element-180">{plan.price}</span>
                <span className="text-gray-400 ml-2" data-id="element-181">{plan.period}</span>
                {plan.savings && <p className="text-green-500 font-medium mt-1" data-id="element-182">
                    {plan.savings}
                  </p>}
              </div>
              <ul className="space-y-3 mb-8" data-id="element-183">
                {plan.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-184">
                    <Check className="text-green-500 mr-3 mt-1 flex-shrink-0" size={18} data-id="element-185" />
                    <span data-id="element-186">{feature}</span>
                  </li>)}
              </ul>
              <Link to="/signup" className={`block w-full py-3 rounded font-medium text-lg text-center ${plan.popular ? 'bg-red-600 text-white hover:bg-red-700' : 'border border-red-600 hover:bg-red-600/10'} transition-colors`} data-id="element-187">
                Get Started
              </Link>
            </div>)}
        </div>
        <div className="text-center mt-12 text-gray-400 max-w-2xl mx-auto" data-id="element-188">
          <p className="mb-4" data-id="element-189">
            All plans include a 7-day free trial. No credit card required to
            start.
          </p>
          <p data-id="element-190">
            Need a custom solution for your team or company?{' '}
            <Link to="/contact" className="text-red-500 hover:text-red-400 transition-colors" data-id="element-191">
              Contact us
            </Link>{' '}
            for enterprise pricing.
          </p>
        </div>
      </div>
    </section>;
}